export const formErrors = {
    usr_password: [{
        code: 'required',
        message: 'Password required'
    },{
        code:'minlength',
        message: 'Password must have minimun 6 characteres'
    }],
    usr_password_confirm: [{
        code: 'required',
        message: 'Confirm password required'
    },
    {
        code: 'mismatch',
        message: 'Please make sure your passwords match'
    }]
}